<!--
 * @Author: ningbo.kang
 * @Date: 2020-06-24 11:43:42
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2021-01-18 18:40:59
 * @Description: 描述
-->

<template>
  <div
    widget-type="dialog">
    <div class="wg-dialog-wrapper">
      <div class="wg-dialog-select-wrapper">
        <span class="wg-dialog-select-affix-wrapper">
          <a-select v-if="options.mode !== 'link'"
            v-model="text"
            :showArrow="false"
            :open="false"
            :allowClear="true"
            :mode="selectMode"
            :disabled="disabled"
            :placeholder="disabled?'':placeholder"
            @change="handleChange">
            <span slot="removeIcon"></span>
          </a-select>
          <dialog-link v-else
            :value="value"
            :multiple="options.multiple"
            :disabled="disabled"
            @delete="handleDelete" />
        </span>
        <span class="wg-dialog-group-addon"
          v-if="!disabled">
          <a-button type="primary"
            :disabled="disabled"
            icon="search"
            @click="handleSearch" />
        </span>
      </div>
    </div>

    <select-modal-box ref="box"
      :title="configData.title"
      :dialogKey="configData.dialogKey"
      :visible="visible"
      :conditionFields="configData.conditionFields"
      :columns="configData.displayFields"
      :pageSource="pageSource"
      :multiple="options.multiple"
      :width="configData.width"
      :rowKey="configData.rowKey"
      @fetch="handleFetch"
      @cancel="handleCancel"
      @condition="handleCondition"
      @confirm="handleConfirm"></select-modal-box>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';
import selectModalBox from './selectModalBox';
import dialogLink from './link';

export default {
  mixins: [baseMixin],
  components: { selectModalBox, dialogLink },
  props: {
    valueField: {
      type: String,
      default: '',
    },
    keyField: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      options: {
        width: '100%',
        defaultValue: null,
        mode: 'default',
        required: false,
        dataType: 'string',
        pattern: '',
        placeholder: '',
        customClass: '',
        disabled: false,
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        showPassword: false,
        remoteFunc: '',
        remoteOption: '',
      },
      lastVal: '',
      visible: false,
      configData: {
        width: 900,
        rowKey: '',
        conditionFields: { list: [] },
      },
      pageSource: {
        list: [],
        pageSize: 0,
        total: 0,
        pageNum: 0,
      },
      // 动态附加数据条件
      dynamicCondition: {},
      preVal: undefined,
    };
  },
  computed: {
    selectMode() {
      if (this.options.multiple) {
        return 'multiple';
      }
      return 'default';
    },
  },
  methods: {
    initVal(val) {
      // 数据库返回的是字符串，如果是多选，则转化为数组给组件使用
      // this.text值在多选和单选时数据类型是不一样的，多选时必须是数组
      // 如果是多选且默认值不是数组，那么传递的值val是字符串，需要将其转换为数组，
      // 否则直接将val赋值给this.text; 单选val是数组的错误（可能性）不做处理
      if (this.widget.options.mode !== 'link') {
        if (this.widget.options.multiple && !Array.isArray(this.defaultValue)) {
          if (val) {
            this.text = val.split(',');
          } else {
            this.text = [];
          }
        } else {
          this.text = val;
        }
        this.preVal = this.text;
      }
    },
    handleSearch() {
      this.visible = true;
      this.remote
        .formCustDialogGetObject({ key: this.options.remoteFunc })
        .then((resp) => {
          this.configData = this.convertSchemaData(resp.data);
          this.handleFetch();
        })
        .catch(() => {
          // this.configData = this.convertSchemaData(dialogJson);
        });
    },
    handleFetch(filter = { offset: 0, limit: 10 }) {
      this.$refs.box.showLoading();
      this.remote
        .formCustDialogGetListData({ key: this.options.remoteFunc, filter: { ...filter, ...this.dynamicCondition } })
        .then((resp) => {
          const {
            pageSize, list, total, pageNum,
          } = resp.page;
          this.pageSource = {
            pageNum,
            pageSize,
            rows: list,
            total,
          };
          this.$refs.box.closeLoading();

          // this.pageSource = this.convertPageData({
          //   pageSize: 10,
          //   rows: resp.list,
          //   total: resp.list.length,
          // });
        })
        .catch(() => {
          this.$refs.box.closeLoading();
          // this.pageSource = this.convertPageData(pageData);
        });
    },
    showModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm(selectRowkeys, record) {
      this.visible = false;
      if (Array.isArray(selectRowkeys) && selectRowkeys.length > 0) {
        const { multiple } = this.options;
        let items;
        if (multiple) {
          items = [...record];
        } else {
          [items] = record;
        }
        let reVal;
        if (this.options.mode === 'link') {
          reVal = `[${record.map(rec => rec[this.valueField]).join()}]`;
        } else {
          reVal = record.map(rec => rec[this.valueField]).join();
        }
        // 向顶层wgForm注册事件
        if (!this.isNested) {
          const { rowIndex, fieldName: field } = this;
          const value = {
            type: 'dialog',
            rowIndex,
            field,
            value: reVal,
          };
          this.dispatch('wgForm', `on-${this.fieldName}-change`, {
            ...value,
            value: reVal,
          });
          this.dispatch('wgForm', `on-${this.fieldName}-confirm`, {
            ...value,
            value: items,
            delIndex: -1,
          });
        }
        // 将数据抛给上一层，主要是被子表格服务
        // this.$emit('change', item[this.valueField]);
        this.$emit('change', reVal);
        this.$emit('confirm', items);
      }
    },
    // 删除tag索引号
    getDelIndex(cur, pre) {
      return pre.findIndex(item => cur.indexOf(item) === -1);
    },
    handleChange(val) {
      // 清楚数据时
      const { multiple } = this.options;
      let delIndex = -1;
      if (multiple) {
        delIndex = this.getDelIndex(val, this.preVal);
      }
      let newVal;
      let items;
      if (multiple && !Array.isArray(this.defaultValue)) {
        if (this.options.mode === 'link') {
          newVal = JSON.stringify(val);
        } else {
          newVal = val.join();
        }
        items = val.map(itemVal => ({
          [this.valueField]: itemVal,
        }));
      } else {
        newVal = val || this.defaultValue;
        items = {
          [this.valueField]: newVal,
        };
      }
      if (!this.isNested) {
        const { rowIndex, fieldName: field } = this;
        const value = {
          type: 'dialog',
          rowIndex,
          field,
          value: '',
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, {
          ...value,
          value: '',
        });
        this.dispatch('wgForm', `on-${this.fieldName}-confirm`, {
          ...value,
          value: items,
          delIndex,
        });
      }
      this.$emit('change', newVal);
      this.$emit('confirm', items);
    },

    handleDelete(val) {
      this.handleChange(val);
    },

    // convertData
    convertSchemaData(data) {
      const result = {};
      const { name, width = 900, key } = data;
      result.title = name;
      result.width = width;
      result.rowKey = this.keyField;
      result.dialogKey = key;
      result.conditionFields = {
        list: [],
        config: {
          labelWidth: 100,
          labelPosition: 'right',
          size: 'small',
          customClass: '',
          model: 'queryModel',
        },
      };

      // 当前列是否是参与排序
      const isSorter = (columnName) => {
        if (data.sortFields.findIndex(item => item.columnName === columnName) > -1) {
          return true;
        }
        return false;
      };

      data.conditionFields.forEach((item) => {
        const {
          showName, columnName, condition, value, dbType,
        } = item;
        let model = columnName;
        if (condition === 'LK' && dbType === 'varchar') {
          model += '^VLK';
        } else if (condition === 'LK' && dbType === 'number') {
          model += '^NLK';
        } else if (condition === 'LK' && dbType === 'date') {
          model += '^DLK';
        } else if (condition === 'EQ' && dbType === 'varchar') {
          model += '^VEQ';
        } else if (condition === 'GE' && dbType === 'date') {
          model += '^DGE';
        } else if (condition === 'LE' && dbType === 'date') {
          model += '^DLE';
        }

        const { ctrlType } = value;
        if (ctrlType === 'inputText') {
          const widget = {
            type: 'input',
            icon: 'icon-input',
            name: showName,
            options: {
              width: '100%',
              defaultValue: '',
              required: false,
              dataType: '',
              pattern: '',
              placeholder: this.t('wg.inputPlaceholder'),
              customClass: '',
              disabled: false,
              hidden: false,
              dataBind: true,
              remoteFunc: '',
              remoteOption: '',
              tooltip: '',
              span: 24,
            },
            rules: [],
            key: model,
            model,
          };
          result.conditionFields.list.push(widget);
        }
        if (ctrlType === 'inputDate') {
          const widget = {
            type: 'date',
            name: showName,
            options: {
              defaultValue: '',
              readonly: false,
              disabled: false,
              editable: true,
              clearable: true,
              placeholder: '',
              startPlaceholder: '',
              endPlaceholder: '',
              type: 'date',
              format: 'YYYY-MM-DD',
              timestamp: false,
              required: false,
              width: '',
              customClass: '',
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: '',
              remoteOption: '',
            },
            rules: [],
            key: model,
            model,
          };
          result.conditionFields.list.push(widget);
        }
      });

      // 添加特殊过滤条件
      if (key === 'listExpenses') {
        const widget = {
          type: 'radio',
          icon: 'icon-radio-active',
          name: '类型',
          options: {
            inline: false,
            defaultValue: 'dept',
            showLabel: false,
            options: [
              {
                value: 'dept',
                label: '部门',
              },
              {
                value: 'project',
                label: '项目',
              },
            ],
            required: false,
            width: '',
            remote: false,
            remoteOptions: [],
            props: {
              value: 'value',
              label: 'label',
            },
            remoteFunc: '',
            remoteOption: '',
            disabled: false,
            hidden: false,
            span: 12,
          },
          rules: [],
          key: 'type',
          model: 'type^VEQ',
        };
        result.conditionFields.list.push(widget);
        // this.setCondition({
        //   type: 'aa',
        // });
        this.setCondition({ 'type^VEQ': 'dept' });
      }
      // end

      result.displayFields = data.displayFields.map((item) => {
        const { columnName: dataIndex, showName: title } = item;
        return { dataIndex, title, sorter: isSorter(dataIndex) };
      });
      return result;
    },

    convertPageData(data) {
      const result = {};
      const { pageSize, rows, total } = data;
      result.pageSize = pageSize;
      result.rows = rows;
      result.total = total;
      return result;
    },

    /**
     * 设置：动态附加数据条件
     */
    setCondition(condition = {}) {
      this.dynamicCondition = condition;
    },
    handleCondition(condition) {
      this.setCondition(condition);
      this.handleFetch();
    },
  },
};
</script>
